import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete, AiOutlineEye } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { getProducts, deleteAProduct } from "../features/product/productSlice";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";
const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "title",
    sorter: (a, b) => a.title.length - b.title.length,
  },
  // {
  //   title: "Brand",
  //   dataIndex: "brand",
  //   sorter: (a, b) => a.brand.length - b.brand.length,
  // },
  {
    title: "Category",
    dataIndex: "category",
    sorter: (a, b) => a.category.length - b.category.length,
  },
  {
    title: "Promotional Type",
    dataIndex: "promo",
  },
  {
    title: "Price",
    dataIndex: "price",
    sorter: (a, b) => a.price - b.price,
  },
  {
    title: "Show Price",
    dataIndex: "show_price",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Productlist = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);
  const [open, setOpen] = useState(false);
  const [pCatId, setpCatId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setpCatId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const productState = useSelector((state) => state.product.products);
  // const data1 = [];
  // for (let i = 0; i < productState.length; i++) {
  //   data1.push({
  //     key: i + 1,
  //     title: productState[i].title,
  //     brand: productState[i].brand,
  //     category: productState[i].category,
  //     color: productState[i].color,
  //     price: `${productState[i].price}`,
  //     action: (
  //       <>
  //         <Link to="/" className=" fs-3 text-danger">
  //           <BiEdit />
  //         </Link>
  //         <Link className="ms-3 fs-3 text-danger" to="/">
  //           <AiFillDelete />
  //         </Link>
  //       </>
  //     ),
  //   });
  // }

  if (!Array.isArray(productState)) {
    return <div>Loading...</div>;
  }

  const data1 = productState.map((product, index) => ({
    key: index + 1,
    title: product.product_name,
    // brand: product.brand.name,
    category: product.category ? product.category.category_name : "N/A",
    promo: product.promo_type ? product.promo_type.promotype_name : "N/A",
    price: `${product.price}`,
    show_price: (
      <span className={`badge ${product.show_price !== false ? 'bg-success' : 'bg-danger'}`}>
        {product.show_price !== false ? 'Yes' : 'No'}
      </span>
    ),
    action: (
      <>
        <Link
          className="ms-3 fs-3 text-danger"
          to={`/admin/list-product/${productState[index]._id}`}
        >
          <AiOutlineEye />
        </Link>
        {/* <Link to="/" className="fs-3 text-danger">
          <BiEdit />
        </Link> */}
        <Link
          to={`/admin/product/${productState[index]._id}`}
          className=" fs-3 text-danger"
        >
          <BiEdit />
        </Link>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(productState[index]._id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  const deleteCategory = (e) => {
    dispatch(deleteAProduct(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getProducts());
    }, 100);
  };
  console.log(data1);
  return (
    <div>
      <h3 className="mb-4 title">Products</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteCategory(pCatId);
        }}
        title="Are you sure you want to delete this Product Category?"
      />
    </div>
  );
};

export default Productlist;
